import React from 'react';
import './Market.css';

const marketLocations = [
  {
    city: "Kothota",
    image: "/images/kothata.jpg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3832.376894862042!2d81.51302407494067!3d16.426038484297894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37f401d5d01591%3A0x6d0a5aee7f62e95!2sKothota%2C%20Andhra%20Pradesh%20534281!5e0!3m2!1sen!2sin!4v1718112345678"
  },
  {
    city: "Bhimavaram",
    image: "/images/bhimavaram.jpg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3832.376894862042!2d81.51302407494067!3d16.426038484297894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37f401d5d01591%3A0x6d0a5aee7f62e95!2sKothota%2C%20Andhra%20Pradesh%20534281!5e0!3m2!1sen!2sin!4v1718112345678"
  },
  {
    city: "Vijayawada",
    image: "/images/vijayawada.jpeg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.9371691671466!2d80.62845687498175!3d16.504398684232378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fbdf2b72dd19%3A0x7eac61a6a87d0d0a!2sLabbipet%2C%20Vijayawada%2C%20Andhra%20Pradesh%20520010!5e0!3m2!1sen!2sin!4v1718112345678"
  },
  {
    city: "Hyderabad",
    image: "/images/cable_bridge.jpg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3360069510385!2d78.38624507496463!3d17.44946060433144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e9f775799b%3A0xb64a7611b4963c3b!2sMadhapur%2C%20Hyderabad%2C%20Telangana%20500081!5e0!3m2!1sen!2sin!4v1718112345678"
  },
  {
    city: "Bhubaneswar",
    image: "/images/orissa.jpeg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3819.123456789!2d85.123456789!3d20.123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a123456789abcdef%3A0x123456789abcdef!2sBhubaneswar%2C%20Odisha!5e0!3m2!1sen!2sin!4v1718112345678"
  },
  {
    city: "Kolkata",
    image: "/images/kolkata.jpg",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.170194960832!2d88.42685507499926!3d22.60626033662692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277572f524e6d%3A0x90a0601e53086e37!2sSector%20V%2C%20Salt%20Lake%20City%2C%20Kolkata%2C%20West%20Bengal%20700091!5e0!3m2!1sen!2sin!4v1718112345678"
  }
];

function Market() {
  return (
    <div className="market-page">
      {/* Hero Image */}
      <div className="about-hero-image">
        <img src="/images/market.png" alt="Indian Market Reach" />
      </div>

      {/* Section Content */}
      <section className="about-content-section">
        <h2>Market Presence in India</h2>
        <p>
          Sharanga Aqua Farms has established strong operational and market roots across India. From coastal Andhra to the heart of Telangana and eastern trade points like Kolkata and Bhubaneswar, we ensure consistent product flow and reliable partnerships.
        </p>
      </section>

      {/* Grid of Locations */}
      <div className="market-grid">
        {marketLocations.map((loc, index) => (
          <div className="market-card" key={index}>
            <img src={loc.image} alt={loc.city} className="market-city-img" />
            <h4>{loc.city}</h4>
            <div className="market-map-embed">
              <iframe
                src={loc.mapSrc}
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={loc.city}
              ></iframe>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Info */}
      <section className="market-bottom-info">
        <h3>Strengthening Domestic Supply Chains</h3>
        <p>
          Our growing network enables better coordination, traceability, and logistics within India.
          By anchoring local supply points and market centers, Sharanga Aqua Farms ensures freshness and availability
          across all operational hubs. We are focused on scalability, sustainability, and service.
        </p>
      </section>
    </div>
  );
}

export default Market;
